import Box from '@mui/material/Box'
import type { SxProps, Theme } from '@mui/material/styles'
import {
  RiAlertLine,
  RiCheckboxCircleLine,
  RiErrorWarningLine,
  RiInformationLine,
} from '@/shared/icons/remix'

const iconWrapSx: SxProps<Theme> = {
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: 24,
  height: 24,
  flexShrink: 0,
  color: 'inherit',
}

/** Figma 5117-10453 — Remix alert-line (triangle + !), not error-warning-line (circle + !). */
export function ToastErrorIcon() {
  return (
    <Box component="span" sx={iconWrapSx} aria-hidden>
      <RiAlertLine size={24} />
    </Box>
  )
}

/** Figma success toast — Remix checkbox-circle-line */
export function ToastSuccessIcon() {
  return (
    <Box component="span" sx={iconWrapSx} aria-hidden>
      <RiCheckboxCircleLine size={24} />
    </Box>
  )
}

/** Figma info toast — Remix information line */
export function ToastInfoIcon() {
  return (
    <Box component="span" sx={iconWrapSx} aria-hidden>
      <RiInformationLine size={24} />
    </Box>
  )
}

export function ToastWarningIcon() {
  return (
    <Box component="span" sx={iconWrapSx} aria-hidden>
      <RiErrorWarningLine size={24} />
    </Box>
  )
}
